import React from 'react';
import {_GPY} from '../../../env.js'
import GpyToggleButton from './GpyToggleButton.js';

class ScoreboardStats extends  React.Component {

	constructor(props) {
		super(props);

		this.state = {
				needPeriodIndex : this.props.needPeriodIndex!==undefined?this.props.needPeriodIndex:false,
	 	};
	}

	componentDidMount() {
	}


  render () {
		const sponsorLogo = this.props.scoreboard.state.currentGame.sponsorLogo!==undefined&&this.props.scoreboard.state.currentGame.sponsorLogo!==''?this.props.scoreboard.state.currentGame.sponsorLogo:"empty.png";
    return (
			<>
			<div className="row" style={this.state.needPeriodIndex&&this.props.scoreboard.state.currentPeriodIndex<=0?{pointerEvents:"none",opacity: "0.4"}:{pointerEvents:"auto",opacity: "1"}}>
			<div className="col-12 p-1"><strong>{_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_stats_title')}</strong></div>

			<div className="col-3 p-1">
			<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_stats_button_fullstats')}
				onInit={() => {return {}}}
				onDeactivate={() => {return {visible: false}}}
				onActivate={() => {
					var home_goal_Log = [_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_stats_fullstats_goals_title'),""];
					var guest_goal_Log = [_GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_stats_fullstats_goals_title'),""];

					this.props.scoreboard.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.key==="GOAL" && e.team === (""+this.props.scoreboard.state.teamMap.HOME_TEAM.id)).forEach((e) =>  {
						var minF = (parseInt(e.timerOffset)/1000) / 60 ;
						var minI = Math.floor(minF) ;
						var formatMin = ('00'+minI).slice(-2);
						home_goal_Log.push("'"+formatMin + " " + e.key + " " + e.value);
					});

					this.props.scoreboard.state.components['gamelog'].state.gameLog.GameLog.elements.filter(e => e.key==="GOAL" && (""+this.props.scoreboard.state.teamMap.GUEST_TEAM.id)===e.team).forEach((e) =>  {
						var minF = (parseInt(e.timerOffset)/1000) / 60 ;
						var minI = Math.floor(minF) ;
						var formatMin = ('00'+minI).slice(-2);
						guest_goal_Log.push("'"+formatMin + " " + e.key + " " + e.value);
					});

					var playerListHome = [];
					this.props.scoreboard.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_PLAYER')).forEach((p)=>{
						var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						playerListHome.push(name);
					});
					var playerListGuest = [];
					this.props.scoreboard.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_PLAYER')).forEach((p)=>{
						var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						playerListGuest.push(name);
					});
					var playerListSubHome = [];
					this.props.scoreboard.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('HOME_TEAM_SUBSTITUE')).forEach((p)=>{
						var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						playerListSubHome.push(name);
					});
					var playerListSubGuest = [];
					this.props.scoreboard.state.currentGame.players.Player.filter(p => p.vsRole.startsWith('GUEST_TEAM_SUBSTITUE')).forEach((p)=>{
						var name = (p.numOrPos!==undefined && p.numOrPos!==''? p.numOrPos +" ":"") + (p.firstName!==undefined && p.firstName!==''? p.firstName +" ":"") + (p.lastName!==undefined&&p.lastName!==''?p.lastName:"");
						playerListSubGuest.push(name);
					});

					return {
						visible: true,
						guest_score: this.props.scoreboard.getCurrentGuestScore(),
						home_score: this.props.scoreboard.getCurrentHomeScore(),

						home_goal_log: home_goal_Log,
						guest_goal_log: guest_goal_Log,

						periode: _GPY.i18n.get('gametype_'+this.props.scoreboard.getName()+'_scoreboard_message_periods_'+this.props.scoreboard.state.currentPeriodIndex),
						game: this.props.scoreboard.state.currentGame,
						sponsorLogo: sponsorLogo,
						playerListHome:playerListHome,
						playerListGuest:playerListGuest,
						playerListSubHome:playerListSubHome,
						playerListSubGuest:playerListSubGuest,

					}}}
					scoreboard={this.props.scoreboard}
					getTime={()=>this.props.scoreboard.getCurrentMainTime()} getGameId={()=>this.props.scoreboard.getCurrentGameId()}
					stateName={this.props.scoreboard.getName()+"_button_full_statistics"}
				 />
			</div>

			</div>
		 </>
		);
  }
}
export default ScoreboardStats;
